import * as React from 'react';

import { Alert, Button } from 'antd';

import ConfirmationAlert from 'components/Alert';
import webhookService from 'v2/services/webhook2';

type UnifyUrlData = {
  allUrlsAreUnified: boolean;
  duplicatedCount: number;
};

export default function UnifyDuplicatedUrl() {
  const [loading, setLoading] = React.useState<boolean>();
  const [data, setData] = React.useState<UnifyUrlData>({
    allUrlsAreUnified: true,
    duplicatedCount: 0
  });

  const hasUrlsToUnify = async () => {
    try {
      const data = await webhookService.hasUrlsToUnify();

      setData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setLoading(true);
    hasUrlsToUnify();
  }, []);

  const askForConfirmation = async () => {
    const confirm = await ConfirmationAlert.show({
      message: (
        <>
          <p>
            Agora, você pode criar um Webhook para mais de 1 ou 2 produtos. Unifique suas URLs duplicadas e gerencie
            seus dados sem redundância, garantindo precisão em suas análises.
          </p>

          <p className='mt-2.5 text-sm text-gray-500'>
            * As mudanças podem levar até alguns minutos para serem refletidas.
          </p>
        </>
      ),
      title: 'Simplifique suas integrações com essa novidade!',
      confirmation: true
    });

    if (confirm) {
      await webhookService.unifyUrls();
      setLoading(false);
      setData({
        allUrlsAreUnified: true,
        duplicatedCount: 0
      });

      return;
    }
  };

  if (loading || data.allUrlsAreUnified) {
    return null;
  }

  return (
    <>
      <Alert
        type='info'
        className='mb-8'
        message='Temos uma novidade para você!'
        description={
          <p>
            Agora, você pode configurar um webhook para receber notificações de diversos produtos em um mesmo webhook.
            Isso diminui a quantidade de configurações necessárias e facilita a integração com a nossa plataforma.
          </p>
        }
        action={
          <Button id='webhook-v2-button-unify-products' onClick={() => askForConfirmation()}>
            Unificar Webhooks
          </Button>
        }
      />
    </>
  );
}
